import {useDispatch, useSelector} from "react-redux";
import InputComponent from "../../../components/input.component";
import React from "react";
import {setMainPageFlashSaleDetail} from "../../../reducers/main-page.reducer";

const GeneralForm = ({fieldList}) => {
    const dispatch = useDispatch()
    const {flashSaleDetail, mainPageErrorMessage} = useSelector(state => state.mainPageReducer)

    const onChangeInput = (key, value) => {
        dispatch(setMainPageFlashSaleDetail({[key]: value}))
    }

    return (
        <div className={"grid grid-cols-2 gap-x-16 gap-y-4"}>
            {fieldList.map((item, index) => (
                <div key={index} className={item.key === 'icon_flash_sale' ? 'col-span-2' : ''}>
                    <InputComponent item={item} data={flashSaleDetail[item.key]} onChange={onChangeInput} error={mainPageErrorMessage}/>
                </div>
            ))}
        </div>
    )
}

export default GeneralForm